/* eslint-disable max-len */
export default {
  regionShortName: 'ХМАО-Югра',
  regionFullName: 'Ханты-Мансийский автономны округ-Югра',
  siteDepartment: 'https://kmns.admhmao.ru/',
  systemType: 'ГИС',
  systemTypeFull: 'Государственная информационная система',
  systemShortName: '«КМНС»',
  systemName: '«Коренные малочисленные народы Севера»',
  systemFullName: 'ГИС «Коренные малочисленные народы Севера»',
  systemDescription: `Региональная платформа поддержки коренных малочисленных народов севера разработана с целью
          оказания максимальной поддержки и предоставления услуг коренным малочисленным народам
          Севера Ханты-Мансийского автономного округа – Югры. Мы стремимся к максимальному развитию,
          предоставлению мер поддержки и услуг, связанной с коренными малочисленными народами Севера`,
  support: {
    address:
      '628011, Ханты-Мансийский автономный округ-Югры, г.&nbsp;Ханты-Мансийск, ул. Мира, д.151',
    phone: '',
    email: "helpdesk{'@'}admhmao.ru",
    description: 'Служба технической поддержки работает по будням с 9 до 18',
  },
  service: {
    filter: {
      organizationName: 'Организация или подразделение',
    },
  },
  svo: {
    columnLabel: 'СВО',
    filterLabel: 'Статус отношения к СВО',
    category: {
      svo: 'Участник СВО',
      family_svo: 'Член семьи участника СВО',
      none: 'Нет данных',
    },
    launchFamilyButton: 'Запросить справку Минобороны по семье',
    launchFamilyConfirm:
      'Будет запущен запрос справки Минобороны по всем совершеннолетним членам семьи. Продолжить?',
    launchFamilySuccess: 'Запрос по семье запущен. Ожидайте завершения в журнале запросов.',
  },
  ttp: {
    ttpTitle: 'ТТП',
    newHouseholdSelectLabel: 'ттп, в котором будет создано новое домохозяйство',
    ttpTitleColumn: 'Данные реестра',
    ttpFullTitle: 'Территория традиционного природопользования',
    ttpFullTitleRod: 'Территорий традиционного природопользования',
    ttpRegistry: 'Реестр ТТП',
    householdTitle: 'Домохозяйства',
    householdTitleRod: 'Домохозяйства',
    householdTitleVin: 'Домохозяйство',
    householdTitlePr: 'Домохозяйстве',
    householdTitlePlural: 'Домохозяйств | Домохозяйство | Домохозяйства',
    householdDelegate: 'Представителей | Представитель | Представителя',
    householdDelegateTv: 'Представителем',
    householdNew: 'Новое @:ttp.householdTitleVin',
    householdCurrent: 'Текущее',
    householdDelegateWithBirthDate: '{fio}, {birthDate} г.р.',
    householdDelegateMissing: 'Представитель не указан',
    householdOptionBirthDate: 'Дата рождения:',
    householdOptionBirthDateMissing: 'Дата рождения не указана',
    householdOptionMembersCount: 'Членов семьи: {count}',
    addToFamilyWhenCreated: 'Так же добавить физлицо в домохозяйство',
    createNewHousehold: 'Новая семья',
    householdEmptyMessage:
      'В данном @:ttp.ttpTitle не зарегистрированы @:ttp.householdTitleRod ведущие традиционное природопользование',
    communesEmptyMeesage: 'В данном ТТП не зарегистрированы общины',
    report: {
      statisticsDataDepartmentEveryYear:
        'Статистические данные Департамента недропользования и природных ресурсов Ханты-Мансийского автономного округа – Югры таблица на каждый год',
      finalIndicatorsLegalEntitiesByTypeActivity:
        'Информация из Реестра территорий традиционного природопользования коренных малочисленных народов Севера регионального значения в ХМАО',
      demographyReport:
        'Информация по Реестру территорий традиционного природопользования коренных малочисленных народов Севера регионального значения в ХМАО по количеству родившихся (включенных) / умерших (исключенных)',
    },
  },
  tmcConflict: {
    title: 'Выписка из реестра ТМЦ',
    openRecord: 'Перейти к ТМЦ',
    familyMember: 'член семьи',
    reasonProvided: '{resource} выдано {date}, {person}, запись №{recordId}',
    reasonQueue: '{resource}, дата постановки {date}, {person}, запись №{recordId}',
    reasonSent: '{resource}, дата отправки уведомления {date}, {person}, запись №{recordId}',
    reasonDraft: '{resource}, дата создания {date}, {person}, запись №{recordId}',
    hintConflict: 'уже существует незакрытая запись',
    hintComposition: 'конфликт состава комплекта',
    hintUsage: 'не прошёл срок использования',
    checkError:
      'Не удалось выполнить проверку реестра материальных средств (заявитель или семья не найдены)',
    noConflicts:
      'Отсутствуют записи в очереди ТМЦ и выданные ранее матсредства, срок пользования которых не истек',
  },
  documents: {
    actionsMenu: 'Действия с файлом',
    preview: 'Предварительный просмотр',
    previewDesc: 'Открыть содержимое файла во всплывающем окне без скачивания',
    download: 'Скачать',
    downloadDesc: 'Сохранить файл на компьютер',
    move: 'Переместить',
    moveDesc: 'Убрать из этой папки и положить в другую',
    copyShortcut: 'Создать ярлык',
    copyShortcutDesc: 'Скопировать ссылку на файл в другую папку',
    removeFromFolder: 'Убрать из папки',
    removeFromFolderDesc: 'Отвязать файл только от этой папки; сам файл останется в системе',
    deletePermanently: 'Удалить навсегда',
    deletePermanentlyDesc: 'Удалить файл из системы целиком. Действие необратимо',
    moveFolder: 'Переместить папку',
    copyFolder: 'Копировать папку',
    confirmRemoveFromFolder:
      'Убрать файл из этой папки? Сам файл останется в системе, если он есть в других местах.',
    confirmDeletePermanently: 'Удалить файл навсегда? Это действие необратимо.',
    deleteBlocked: 'Файл используется в других разделах и не может быть удалён навсегда.',
    folderPicker: {
      current: 'Текущая папка',
      back: 'Назад',
      selectHere: 'Выбрать',
      selectCurrent: 'Выбрать текущую',
      cancel: 'Отмена',
      loading: 'Загрузка папок…',
      moveTitle: 'Выберите папку для перемещения',
      copyTitle: 'Выберите папку для копирования',
      moveFileTitle: 'Выберите папку для перемещения файла',
      linkFileTitle: 'Выберите папку для ярлыка',
      foreignEntityHint: 'В данную папку невозможно перенести/скопировать',
      readonlyHint: 'Папка только для чтения',
      excludedHint: 'Сюда переместить нельзя',
    },
  },
  commissions: {
    protocol: {
      fileHint: 'Файл протокола будет сформирован после утверждения',
      regenerate: 'Сформировать заново',
      regenerateConfirm: 'Сгенерированный файл будет заменён. Продолжить?',
    },
  },
  userActivityStatistics: {
    pageTitle: 'Статистика активности',
    loginPageTitle: 'Статистика по пользователям системы',
    issuePageTitle: 'Статистика по поданным заявлениям',
    menuLogins: 'Пользователи',
    menuIssues: 'Заявления',
    viewTable: 'Таблица',
    viewChart: 'График',
    fromDate: 'Начало периода, день включительно',
    toDate: 'Конец периода, день включительно',
    intervalDay: 'по дням',
    intervalWeek: 'по неделям',
    intervalMonth: 'по месяцам',
    roles: 'Роли',
    services: 'Услуги',
    apply: 'Применить',
    reset: 'Сбросить',
    export: 'Экспорт',
    loginChartTitle: 'Число уникальных авторизаций пользователей системы',
    issueChartTitle: 'Поданные заявления по услугам',
    noChartData: 'Нет данных для графика за выбранный период',
    submittedUserSeries: 'При помощи портала или ЕПГУ',
    hints: {
      interval: 'Как сгруппировать строки?',
    },
    columns: {
      period: 'Период',
      role: 'Роль',
      countUser: 'Уникальные пользователи',
      service: 'Услуга',
      countIssue: 'Количество заявлений',
      countSubmittedUser: 'При помощи портала или ЕПГУ',
    },
  },
  reportForms: {
    downloadTemplate: 'Скачать шаблон',
    uploadTemplate: 'Имопортировать из шаблона',
    templateDialogTitle: 'Скачать шаблон',
    templateFormat: 'Формат файла',
    templateFormatHint: 'Файл XLSX или CSV. Не меняйте служебные строки и структуру таблицы.',
    download: 'Скачать',
    cancel: 'Отмена',
    formatXlsx: 'XLSX',
    formatCsv: 'CSV',
    sign: 'Подписать',
    signAgain: 'Подписать заново',
    signDialogTitle: 'Выбор сертификата',
    signRequired: 'Перед отправкой на проверку подпишите отчёт УКЭП',
    resignConfirm:
      'Сформировать файл заново? Текущая подпись перестанет относиться к этому отчёту.',
    noCertificatesLead: 'У вас нет сертификатов для подписания. Добавьте их в разделе ',
    noCertificatesLink: '«Мои сертификаты»',
    selectCertificate: 'Выберите сертификат, который хотите использовать',
    signCertificatesLoading: 'Загрузка сертификатов. Подтвердите доступ к плагину, если браузер запросит.',
    attachment: 'Приложение (необязательно)',
    attachmentPlaceholder: 'Прикрепить файл',
    attachmentSaved: 'Приложение прикреплено',
    fillTab: 'Заполнение',
    multiPeriodSummary: 'Свод по нескольким периодам',
  },
};
